<template>
    <router-link v-on:click.native="searchCategory(category, 2, label)" v-bind:to="`#${category}`" replace v-if="category">
        <div class="d-flex flex-column mt-2">
            <div><span class="item_label">{{label}}</span></div>
            <div class="mt-2"><b-img v-lazy="setCfUrl(iconPath)" height="60px"></b-img></div>
        </div>
    </router-link>
</template>

<script>
    import {mapActions} from "vuex";

    export default {
        name: "Category",
        props: ["category", "label", "iconPath"],
        methods: {
            ...mapActions(["search", 'statistics']),
            searchCategory(word, type, value) {
                this.statistics({type, value});
                this.search(word);
            },
            setCfUrl(path){
                if(path && process.env.VUE_APP_FAQ_CF_URL){
                    path = path.replace(process.env.VUE_APP_FAQ_URL, process.env.VUE_APP_FAQ_CF_URL);
                }
                return path;
            }
        },
    };
</script>

<style scoped>
    .item_label {
        width: 100%;
    }
    img[lazy=error] {
        display: none;
    }
</style>
